import type { SVGProps } from 'react';

const SvgCloseFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 2C17.5228 2 21.9999 6.47719 22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5229 2 12C2.00014 6.47718 6.47724 2 12 2ZM16.5303 7.46973C16.2374 7.17683 15.7626 7.17683 15.4697 7.46973L12 10.9395L8.53027 7.46973C8.23738 7.17683 7.76262 7.17683 7.46973 7.46973C7.17683 7.76262 7.17683 8.23738 7.46973 8.53027L10.9395 12L7.46973 15.4697C7.17683 15.7626 7.17683 16.2374 7.46973 16.5303C7.76262 16.8232 8.23738 16.8232 8.53027 16.5303L12 13.0605L15.4697 16.5303C15.7626 16.8232 16.2374 16.8232 16.5303 16.5303C16.8232 16.2374 16.8232 15.7626 16.5303 15.4697L13.0605 12L16.5303 8.53027C16.8232 8.23738 16.8232 7.76262 16.5303 7.46973Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgCloseFilled;
